<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" @close="reset" @cancel="reset" />
</template>
<script>
	import { Activity } from '@/modules/aut/data/activity/create'
	import { ActivityService } from '@/modules/aut/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return Activity;
			},

			service()
			{
				return new ActivityService();
			}
		},
		methods:
		{
			async import(payload)
			{
				try
				{
					return await this.service.create(payload, {HSR:false, HER:false});
				} catch (e) { console.log(e) }
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>